<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<div class="flex-shrink-0 py-5 d-flex flex-column bg-grey200">
			<section class="inner container ">
				<div class="center-contain pt-5 text-center">
					<h1 class="pricing-heading">Select payment method</h1>
					<p class="lead my-4">
						Your subscription starts as soon as you set up payment.
					</p>
					<h5 class="my-4"><strong>Cancel online anytime </strong></h5>
					<small class="my-2">Secure Server <i class="fa fa-lock"></i></small>
				</div>
			</section>
			<section class=" pb-0">
				<div class="container">
					<div class="row justify-content-center my-3">
						<div class="col-md-8">
							<div class="card method">
								<div class="card-body" @click="setCard()">
									<ul class="d-flex list-unstyled m-0">
										<li><img src="../../assets/img/card.svg" /></li>
										<li>Pay with Card</li>
										<li>
											<div class="d-flex">
												<span  class="img pointer"
													><img src="../../assets/img/mastercard.png"
												/></span>
												<span  class="img pointer"
													><img src="../../assets/img/visa.png"
												/></span>
												<span class="img pointer"
													><img src="../../assets/img/paypal.png"
												/></span>
												<span class="img pointer"
													><img src="../../assets/img/ussd.png"
												/></span>
												<span @click="openFlutterWave()" class="img pointer"
													><img src="../../assets/img/flutterwave1.png"
												/></span>
											</div>
										</li>
										<li class="ml-auto"><i class="fa fa-angle-right"></i></li>
									</ul>
								</div>
							</div>
							<div class="card method" >
								<div class="card-body" @click="setMobile('glo')">
									<ul class="d-flex list-unstyled m-0">
										<li><img src="../../assets/img/Glo_button.png" /></li>
										<li class="cursor-pointer" >
											Pay with Glo Mobile Money
										</li>
										<li class="ml-auto"><i class="fa fa-angle-right"></i></li>
									</ul>
								</div>
							</div>
							<div class="card method">
								<div class="card-body" @click="setCash()">
									<ul class="d-flex list-unstyled m-0">
										<li><img src="../../assets/img/museum.svg" /></li>
										<li>Pay with Cash</li>
										<li>
											<div class="d-flex">
												<span class="img pointer" 
													><img src="../../assets/img/GTBank.png"
												/></span>
												<span class="img pointer" 
													><img src="../../assets/img/uba.png"
												/></span>
												<span class="img pointer" 
													><img src="../../assets/img/Zenith_Bank.png"
												/></span>
												<span class="img pointer" 
													><img src="../../assets/img/FirstBank.png"
												/></span>
												<span class="img pointer"
													><img src="../../assets/img/FidelityBank.png"
												/></span>
											</div>
										</li>
										<li class="ml-auto"><i class="fa fa-angle-right"></i></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="py-5">
						<p class="text-center pt-4">Download App</p>
						<p class="text-center ">
							<img
								src="../../assets/img/google-play.png"
								alt=""
								class="cursor-pointer"
								@click="gotoAppStore('google')"
							/>
							<img
								src="../../assets/img/app-store.png"
								class="ml-2 cursor-pointer"
								alt=""
								@click="gotoAppStore('apple')"
							/>
						</p>
					</div>
				</div>
			</section>
		</div>
		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-center">
				<a href="/#/">Home</a>
				<a href="/#/cookiesprivacy">Privacy Policy</a>
				<a href="/#/terms">Terms of Use</a>
				<a href="/#/faqs">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>
<script>
export default {
	name: "SelectPaymentNig",
	components: {},
	created() {
		
this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
	},
	methods: {
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		setCard() {
			this.$router.push(
				"/payment/" +
					this.$route.params.sid +
					"/" +
					this.$route.params.pid
			);
		},
		openFlutterWave() {
			this.$router.push(
				"/flutterwavepayment/" +
					this.$route.params.sid +
					"/" +
					this.$route.params.pid
			);
		},
		setCash() {
			this.$router.push(
				"/cashpayment/" +
					this.$route.params.pid +
					"/" +
					this.$route.params.sid 
			);
		},
		setMobile(id) {
			this.$router.push(
				"/checkout/" +
					this.$route.params.pid +
					"/" +
					this.$route.params.sid +
					"/" +
					id
			);
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		forgotpassword() {
			this.isActive = true;
			this.showforgotpasswordErr = false;

			if (this.doforgotpassword) {
				var dataToSend = {
					id: this.userid,
				};
				var self = this;
				this.$store.commit("setLoader", true);
				this.$store
					.dispatch("forgetpassword", dataToSend)
					.then((res) => {
						if (res) {
							this.$store.commit("setLoader", false);
							self.showforgotpasswordErr = true;
							self.forgotpasswordErr = res.message;
							setTimeout(function() {
								self.$router.push({ name: "login" });
							}, 10000);
						}
					})
					.catch((err) => {
						this.$store.commit("setLoader", false);
						this.showforgotpasswordErr = true;
						this.forgotpasswordErr = err.response.data.error.message;
					});
			}
		},
	},

	data() {
		return {
			showforgotpasswordErr: false,
			forgotpasswordErr: "",
			isActive: false,
			doforgotpassword: true,
			userid: "",
			password: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
<style scoped>
.pointer {
	cursor: pointer;
}
.cursor-pointer {
	cursor: pointer;
}
.card-body{
	cursor: pointer;
}
.card-body:hover , .card-body:focus{
	border-radius: 10px;
	 border-color: #679F3D !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(149, 209, 76, 0.596) !important;
    box-shadow: 0 0 0 0.2rem rgba(144, 206, 69, 0.61) !important;
}

.py-5{
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
 min-height: 100vh;
}

</style>
